/* eslint-disable @typescript-eslint/ban-types */
import * as React from 'react';
import * as Modal from 'react-modal';
// import ReactModal from 'react-modal';

/* This just wraps react-modal to allow styling the modal overlay,
 you shouldn't have the need to change this at all */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ReactModalAdaptor = ({ ...props }: React.ComponentProps<any>): JSX.Element => {
  Modal.setAppElement('#root'); // suppresses modal-related test warnings.
  const pageWidth = document.getElementsByTagName('body')[0].clientWidth;
  console.log('screen width', pageWidth);
  const customStyles: Modal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: pageWidth < 700 ? '90%' : '40%',
      backgroundColor: 'white',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(32, 32, 32, 0.75)',
      zIndex: 2,
    },
  };

  return <Modal style={customStyles} {...props} />;
};
